import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {displayMyStoreDetailStyles} from './styles'
import StoreHoursTable from '../../../../components/store-selector-modal/storeHoursTable'
import {pxToRem} from '../../../../utills/pxToRem'
import LoadingSpinner from '@salesforce/retail-react-app/app/components/loading-spinner'

const DisplayMyStoreDetails = ({storeDetails = {}, isLoadingDetails}) => {
    const {name, address1, city, stateCode, postalCode, countryCode, phone} = storeDetails
    return (
        <Box sx={displayMyStoreDetailStyles}>
            <Text fontWeight={500}>{name}</Text>
            <Text fontWeight={400}>
                {address1} {city}, {stateCode} {postalCode}{' '}
                {countryCode === 'US' ? 'United States' : countryCode}
            </Text>
            <Box
                as="a"
                href={`tel:${storeDetails.phone}`}
                color={{base: 'cav_calltoaction_darkred', lg: 'cav_calltoaction_darkred'}}
                textDecoration="underline"
                fontSize={{base: pxToRem(12), lg: pxToRem(13)}}
                fontWeight={400}
                letterSpacing={pxToRem(1)}
                _hover={{
                    color: 'cav_hover_brightred'
                }}
            >
                {phone}
            </Box>
            <Box
                display={'flex'}
                flexDirection={'column'}
                gap={pxToRem(16)}
                justifyContent={'space-between'}
                borderWidth={pxToRem(1)}
                marginTop={{base: pxToRem(5), lg: pxToRem(10)}}
                marginBottom={pxToRem(28)}
                color={'black'}
            >
                <StoreHoursTable
                    hoursOnline={storeDetails.c_firstHoursOnline}
                    hoursDefault={storeDetails.c_firstHoursDefault}
                    hoursRows={storeDetails.c_firstHoursRows}
                    hoursName={storeDetails.c_firstHoursName}
                />
                <StoreHoursTable
                    hoursOnline={storeDetails.c_secondHoursOnline}
                    hoursDefault={storeDetails.c_secondHoursDefault}
                    hoursRows={storeDetails.c_secondHoursRows}
                    hoursName={storeDetails.c_secondHoursName}
                />
                <StoreHoursTable
                    hoursOnline={storeDetails.c_thirdHoursOnline}
                    hoursDefault={storeDetails.c_thirdHoursDefault}
                    hoursRows={storeDetails.c_thirdHoursRows}
                    hoursName={storeDetails.c_thirdHoursName}
                />
                <StoreHoursTable
                    hoursOnline={storeDetails.c_fourthHoursOnline}
                    hoursDefault={storeDetails.c_fourthHoursDefault}
                    hoursRows={storeDetails.c_fourthHoursRows}
                    hoursName={storeDetails.c_fourthHoursName}
                />
                <StoreHoursTable
                    hoursOnline={storeDetails.c_fifthHoursOnline}
                    hoursDefault={storeDetails.c_fifthHoursDefault}
                    hoursRows={storeDetails.c_fifthHoursRows}
                    hoursName={storeDetails.c_fifthHoursName}
                />
            </Box>
            {isLoadingDetails && <LoadingSpinner />}
        </Box>
    )
}

DisplayMyStoreDetails.propTypes = {
    storeDetails: PropTypes.object,
    isLoadingDetails: PropTypes.bool
}

export default DisplayMyStoreDetails
